<vdw-crud-overview-data-page class="bms-theme-content pl-48 pr-16" [config]="config"></vdw-crud-overview-data-page>
